export default "__VITE_ASSET__BiBlm_SR__"